<template>
  <v-radio-group
    dense
    :label="label"
    :hint="question.instructionText"
    persistentHint
    :disabled="disabled"
    v-model="question.value"
    :rules="[required ? rules.required : true]"
  >
    <v-radio
      v-for="({ choiceLabel, choiceValue }, index) in choices"
      :key="index"
      :label="choiceLabel"
      :value="choiceValue"
    />
  </v-radio-group>
</template>

<script>
import QuestionMixin from "./QuestionMixin";

export default {
  name: "RadioQuestion",
  methods: {
    evaluateAllExpressions() {
      this.question.expressions.forEach(expression => {
        let satisfied = false;
        switch (expression.condition) {
          case "isBlank":
            satisfied = this.question.value === null;
            break;
          case "isNotBlank":
            satisfied = this.question.value !== null;
            break;
          case "is":
            satisfied = this.question.value === expression.value.value;
            break;
          case "isNot":
            satisfied = this.question.value !== expression.value.value;
            break;
          default:
            break;
        }
        this.$set(expression, "satisfied", satisfied);
      });
    }
  },
  mixins: [QuestionMixin],
  data() {
    return {
      rules: {
        required: val => !!val || val === false || "Required"
      }
    };
  },
  computed: {
    choices() {
      if (!this.question.choices || !this.question.choices.length) return [];

      return this.question.choices.map(choice => {
        if (typeof choice === "string")
          return { choiceLabel: choice, choiceValue: choice };
        else if (typeof choice === "object")
          return { choiceLabel: choice.text, choiceValue: choice.value };
        else throw new Error("Unknown choice type", choice);
      });
    }
  }
};
</script>

<style scoped></style>
